import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto"
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { EntitesDadosEstoque } from "../../Estoque"
import { DadosPedidosFornecedor, PedidosFornecedor } from "./PedidosFornecedor"

export type PedidosFornecedorContainerProps = {
    estoqueSelecionado: EntitesDadosEstoque,
    item: IItemOrcamento,
    //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string,() => void>,
    foraOrcamento: boolean
}

export const PedidosFornecedorContainer = (props: PedidosFornecedorContainerProps) => {

    const [dadosPesquisaPedidosFornecedor, setDadosPesquisaPedidosFornecedor] = useState<PagedMessageResponse<DadosPedidosFornecedor>>()

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
  

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onObterPedidosFornecedor = async () => {
        try {
            const resposta = await microuniversoApi.Produto.pedidoFornecedor({
                CodigoProduto:  props.estoqueSelecionado.Codigo,
                CodigoFilial:  props.estoqueSelecionado.Filial,
                NumeroPagina: 0,
                TamanhoPagina: 0
            })
            setDadosPesquisaPedidosFornecedor(resposta)
        } catch (e) {
            tratamentoErroPadrao(e)
            props.onVoltar()
        } finally {
            globalMU.unblockUI()
        }
    }

    useMenuSubConsulta(props)
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)), props.onVoltar, props.item, props.foraOrcamento)
    
    useEffect(() => {
        passosInterno.current.set("Estoque do Produto", () => props.onVoltar())
        passosInterno.current.set("Pedidos de Fornecedores", () => { })
        onObterPedidosFornecedor()
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
                id="PedidosFornecedorBreadcrumb"
            />

            <br />

            <PedidosFornecedor dadosPedidosFornecedor={dadosPesquisaPedidosFornecedor} />
        </>
    )
}